/**
 * Centralized Status Presentation System.
 *
 * Generic, domain-agnostic infrastructure: any part of the app that has a
 * status vocabulary (competition, draw, category, rule, user, login,
 * athlete attendance, ...) registers ONE mapping of status → presentation
 * metadata here, under its own domain key. Nothing else in the app is
 * allowed to invent its own status→color/icon/label mapping — this file is
 * the single source of truth for WHAT a status means presentationally;
 * `StatusBadge` (the one component with theme access) is the single place
 * that turns a `tone` into an actual color.
 *
 * Deliberately has NO React/theme dependency — a domain's mapping is pure
 * data, trivially testable, and never needs to change when a NEW domain
 * (e.g. a future "competition" or "user" status) is added elsewhere.
 *
 * Presentation metadata shape:
 *   {
 *     tone: 'success'|'warning'|'caution'|'error'|'info'|'neutral',
 *     icon: React component | null,
 *     className: string,
 *   }
 * `tone` is resolved to an actual color exclusively via the theme palette
 * tokens of the same name (front/src/theme/palette.js) — never a literal
 * hex value.
 */
const registry = {};

export const registerStatusDomain = (domain, mapping) => {
    registry[domain] = mapping;
};

export const getStatusPresentation = (domain, status) => {
    const mapping = registry[domain];
    return (mapping && mapping[status]) || null;
};
